/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowIncidentCustomAttributeField {
    getFixupPrototypeFunction() { return ServiceNowIncidentCustomAttributeField.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowIncidentCustomAttributeField>): ServiceNowIncidentCustomAttributeField {
        let obj = Object.assign(new ServiceNowIncidentCustomAttributeField(), model);
        ServiceNowIncidentCustomAttributeField.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowIncidentCustomAttributeField>): ServiceNowIncidentCustomAttributeField {
        if (!model) return null;
        return ServiceNowIncidentCustomAttributeField.newInstance(<ServiceNowIncidentCustomAttributeField> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowIncidentCustomAttributeField) {
        if (!obj) return;

        models.ServiceNowIncidentCustomAttributeField.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowIncidentCustomAttributeField): boolean {
        Object.setPrototypeOf(obj, ServiceNowIncidentCustomAttributeField.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Field Id
     */
    field: string;

    /**
     * Field Name
     */
    field_name: string;

    /**
     * Reference table name of field
     */
    table_name: string;

}
